export default {
  formActions: {
    addPlaceInput: 'Přidat vstupní místo',
    clearRoute: 'Vymazat trasu',
    reverseRoute: 'Obrátit trasu',
    roundTrip: 'Cesta tam a zpět',
    toggleRoundTrip: 'Přepnout zpáteční cestu'
  }
}
